import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaFileInvoice, FaHome, FaCalendarAlt } from 'react-icons/fa';
import './BookingSuccess.css';

const BookingSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingData = location.state?.bookingData;

  useEffect(() => {
    // If no booking data is provided, redirect to home
    if (!bookingData) {
      navigate('/');
      return;
    }

    // No need to save booking here as it's already saved in BookingSummary.js
    // This was causing duplicate bookings

  }, [bookingData, navigate]);

  // Safely format the date to prevent "Invalid Date" errors
  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified';

    try {
      const date = new Date(dateString);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        console.error('Invalid date value:', dateString);
        return 'Date unavailable';
      }

      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return 'Date unavailable';
    }
  };

  if (!bookingData) {
    return null; // Will redirect in useEffect
  }

  return (
    <div className="bs-booking-success-container">
      <div className="bs-success-card">
        <div className="bs-success-icon">
          <FaCheckCircle />
        </div>

        <h1>Booking Pending!</h1>

        <p className="bs-success-message">
          Thank you for choosing Waghchaure Lawns!
          <br />

          Wait for the confirmation from our team.

        </p>

        <div className="bs-booking-details">
          <h2>Booking Details</h2>

          <div className="bs-detail-row">
            <span className="bs-detail-label">Booking ID:</span>
            <span className="bs-detail-value">{bookingData.id || bookingData.bookingId || 'Generated'}</span>
          </div>

          <div className="bs-detail-row">
            <span className="bs-detail-label">Date:</span>
            <span className="bs-detail-value">
              {formatDate(bookingData.bookingForDate || bookingData.date || bookingData.booking_for_date)}
            </span>
          </div>

          <div className="bs-detail-row">
            <span className="bs-detail-label">Time:</span>
            <span className="bs-detail-value">
              {bookingData.startTime || bookingData.start_time} - {bookingData.endTime || bookingData.end_time}
            </span>
          </div>

          <div className="bs-detail-row">
            <span className="bs-detail-label">Event Type:</span>
            <span className="bs-detail-value">
              {bookingData.functionName || bookingData.occasion || bookingData.selectedOccasion || 'Standard Lawn Service'}
            </span>
          </div>

          <div className="bs-detail-row">
            <span className="bs-detail-label">Total Amount:</span>
            <span className="bs-detail-value">₹{(bookingData.totalPaymentAmount || bookingData.total || bookingData.totalAmount || 0).toLocaleString()}</span>
          </div>

          {bookingData.paymentMode && (
            <div className="bs-detail-row">
              <span className="bs-detail-label">Payment Mode:</span>
              <span className="bs-detail-value">{bookingData.paymentMode}</span>
            </div>
          )}
        </div>

        <p className="bs-instructions">
          A confirmation email has been sent to your email address.
          You can view your booking details and invoice in "My Bookings" section.
        </p>

        <div className="bs-action-buttons">
          <Link to="/my-bookings" className="bs-action-button bs-invoice-button">
            <FaFileInvoice />
            <span>View Invoice</span>
          </Link>

          <Link to="/" className="bs-action-button bs-home-button">
            <FaHome />
            <span>Return Home</span>
          </Link>

          <Link to="/my-bookings" className="bs-action-button bs-bookings-button">
            <FaCalendarAlt />
            <span>My Bookings</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess; 